import React, { useEffect } from "react";
import "./Landing.css";
import { LandingProvider, useLanding } from "./LandingContext";
import LandingNav from "./LandingNav";
import LandingFooter from "./LandingFooter";
import { useLandingScroll } from "./useLandingScroll";

function LandingLayoutInner({ children }) {
  const { menuOpen } = useLanding();
  useLandingScroll();

  useEffect(() => {
    document.body.classList.add("chz-landing-body");
    const app = document.querySelector(".App");
    if (app) app.classList.add("chz-landing-app");
    return () => {
      document.body.classList.remove("chz-landing-body");
      if (app) app.classList.remove("chz-landing-app");
    };
  }, []);

  return (
    <div id="chz" className={menuOpen ? "menu-open" : undefined}>
      <LandingNav />
      {children}
      <LandingFooter />
    </div>
  );
}

export default function LandingLayout({ children }) {
  return (
    <LandingProvider>
      <LandingLayoutInner>{children}</LandingLayoutInner>
    </LandingProvider>
  );
}
